/**
 * Удаление лоадера из dom дерева после загрузки страницы
 * Скрипт отрабатывает в любом случае, даже если есть ошибки в JS
 */
$(document).ready(function() {
    /** лоадер перенсен в doc ready из window on load */
    let removePreloader = () => {
        $('body').removeClass('loaded');
        let loader = document.querySelector('.loader');
        loader.parentNode.removeChild(loader);
    }
    removePreloader();

    /** Глобальные переменные */
    var WIN = $(window),
        DOC = $(document),
        HTML = $('html'),
        BODY = $('body');

    /** Определяем браузеры Internet Explorer 11 и Edge */
    let ua = window.navigator.userAgent,
        edge_ua = ua.indexOf('Edge/'),
        ie_ua = ua.indexOf('Trident/7.0'),
        edge = 'edge',
        ie = 'ie';
    if (edge_ua > 0) {
        HTML.addClass(edge);
    }
    if (ie_ua + 1) {
        HTML.addClass(ie);
    }

    /** Добавляем стили и скрипты для браузера Internet Explorer 11 */
    if (HTML.hasClass(ie)) {
        HTML.append('<script src="../../js/' + ie + '.js"></script>');
        HTML.append('<link href="../../css/' + ie + '.css" rel="stylesheet">');
    }


    /**
     * Функция переключения типов отображения контента
     *
     *   data-view-title - имя переключалки на каждой конкретной странице. Должно быть уникально, т.к. создаётся
     *      переменная в localStorage, в ней хранится значение вида, который выбрал пользователь
     *
     *   data-view - имя вида отображения. Указывается для каждой кнопки. Сохраняется в localStorage в переменной
     *      с именем из data-view-title
     *
     *   data-view-default - тип, который выбирается по умолчанию при загрузке страницы, если в localStorage не сохранён
     *      выбранный пользователем тип отображения. Указывается только для одной кнопки из списка
     *
     *   data-view-content - в значение этого аттрибута проставляется тип, который выбран пользователем при клике на иконку
     *      или тип по умолчанию, если пользователь не делал выбора. Используется в стилях как родитель, отталкиваясь от
     *      которого мы делаем стилизацию контента в зависимости от выбранного блока
     *
     *      Пример:
     *          [data-view-content=table]
     *              .games__item
     *                  width 100%
     *
     * */
    function viewSwitcher(){

        let current_tab = localStorage.getItem($('[data-view-title]').data('view-title')),
            default_tab = $('[data-view-default]').data('view');

        // при загрузке страницы проверяеместь ли в localStorage сохранённое значение
        if(current_tab !== null){
            // если есть - выбираем соответсвующую кнопку активной и записываем в data-view-content для стилизации
            $('[data-view-content]').attr('data-view-content', current_tab);
            $('[data-view=' + current_tab + ']').addClass('active');
        }
        else{
            // если нет - выбираем активным иконку, которая указана как дефолтная
            $('[data-view-content]').attr('data-view-content', default_tab);
            $('[data-view=' + default_tab + ']').addClass('active');
        }

        // при клике на любую из иконок делаем её активной и записываем в localStorage тип отображения
        DOC.on('click', '[data-view]', function(){
            let tab_type = $(this).data('view'),
                tab_current = $('[data-view-title]').data('view-title'),
                tab_content = $('[data-view-content]');

            if(!$(this).hasClass('active')){
                $('[data-view]').removeClass('active');
            }

            $(this).addClass('active');
            tab_content.attr('data-view-content', tab_type);

            localStorage.setItem(tab_current, tab_type);
        });
        $('.table--payments').attr('data-view-payments', '').attr('data-view-content', 'table');
        let attr = $('[data-view-content]').attr('data-view-payments');
        if(WIN.width() <= 980){

            if (typeof attr !== typeof undefined && attr !== false){
                $('[data-view-content]').attr('data-view-content', 'grid')
            }
        }
        else{
            if (typeof attr !== typeof undefined && attr !== false){
                $('[data-view-content]').attr('data-view-content', 'table')
            }
        }

        // TODO изящнее и универсальнее
        WIN.on('resize', function() {
            let attr = $('[data-view-content]').attr('data-view-payments');

            if(WIN.width() <= 980){
                $('[data-view=grid]').trigger('click');

                if (typeof attr !== typeof undefined && attr !== false){
                    $('[data-view-content]').attr('data-view-content', 'grid')
                }
            }
            else{
                if (typeof attr !== typeof undefined && attr !== false){
                    $('[data-view-content]').attr('data-view-content', 'table')
                }
            }

        });
    }

    viewSwitcher();

    /** ADD cookies List to Grid view for tables **/
    function setTableView() {
        if ($.cookie('TableView') == null) {
            $.cookie('TableView', 'grid-view', {
                path: '/'
            });
        }
        if ($.cookie('TableView') == 'grid-view') {
            $('[data-view-grid]').click();
        }
        if ($.cookie('TableView') == 'table-view') {
            $('[data-view-table]').click();
        }
    }
    setTableView();
    /** END ADD cookies List to Grid view for tables **/


    /** Реализация адаптивности iframe в статьях **/
    $('.article__content iframe').each(function() {
        $(this).wrap('<div class="videowrapper">');
    });
    /** end **/


    $('[data-document-img]').magnificPopup({
        type: 'image'
    })

    /** Инициализация типовых модалок **/
    $('[data-modal]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            }
        }
    });
    /** End Инициализация модалок **/


    /** Инициализация вызова модалок в модалках **/
    $(document).on('click', '[data-modal-in-modal]', (e) => {
        e.preventDefault();
        let url = $(e.currentTarget).attr('href');

        if ($.magnificPopup.instance.isOpen) {
            $.magnificPopup.close();
        }

        setTimeout(() => {
            $.magnificPopup.open({
                items: {
                    src: url,
                },
                type: 'ajax',
                removalDelay: 300,
                closeOnBgClick: true,
                closeBtnInside: false,
                showCloseBtn: true,
                enableEscapeKey: false,
                mainClass: 'user-navigation',
                callbacks: {
                    parseAjax: function (mfpResponse) {
                        mfpResponse.data = "<div class='modal-transactions'>" + mfpResponse.data + "</div>";
                    },
                    beforeOpen: function () {
                        $('body').addClass('blur');
                    },
                    beforeClose: function () {
                        $('body').removeClass('blur');
                    },
                }
            });
        }, 700);

    });

    DOC.on('click', '[data-modal-simple]', (e) => {
        e.preventDefault();
        $.magnificPopup.close()
        let self = $(e.currentTarget)

        setTimeout(function () {
            $.magnificPopup.open({
                items: {
                    src: self.attr('href')
                },
                type: 'ajax',
                removalDelay: 300,
                mainClass: 'mfp-zoom-in',
                callbacks: {
                    parseAjax: function (mfpResponse) {
                        mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
                    },
                    ajaxContentAdded: function () {
                        this.content;
                    },
                    beforeOpen: function () {
                        $('body').addClass('blur');
                    },
                    beforeClose: function () {
                        $('body').removeClass('blur');
                    }
                }
            });

        }, 1000);
    });
    /** End Инициализация вызова модалок в модалках **/



    /** Инициализация кастомных модалок **/
    $('[data-modal-custom]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping-custom'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            }
        }
    });
    /** End Инициализация кастомных модалок **/


    /** Инициализация модального окна, которое невозможно закрыть */
    $('[data-modal--immortal]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        closeOnBgClick: false,
        showCloseBtn: false,
        enableEscapeKey: false,
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            open: function() {
                $('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
            },
            close: function() {
                $('.header').css('width', '100%')
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            }
        }
    });
    /** End **/

    /**
     * Появление и скрытие поля с ответом на секретный вопрос
     * Появление\скрытие инпута в инициализации selectric'a
     **/
    let secret_question = $('[data-secret-question]'),
        secret_answer = $('.secret_answer');
    // secret_question.find('option[value=0]').val('');
    if (secret_question.val()) {
        secret_answer.hide();
    }
    /** End **/


    /** Fix для пагинации таблиц в кабинете игрока (решение под вопросом, костыль из-за бэкендеров) **/
    DOC.on('click', '.pager__item a', function(event) {
        $('html, body').animate({
            scrollTop: $('#table-top').offset().top
        }, 500);
    });
    /** End Fix для пагинации таблиц в кабинете игрока **/

  // --- Fix Hover on mobile ---------------------------------------------------
	fixHover('.games-item', '.games-item__overlay', 'games-item--with-overlay');

	function fixHover(sSelestor, sHover, sActiveClass) {
		DOC.on('mouseenter', sSelestor, function() {
			$(this)
				.find(sHover)
				.parent()
				.addClass(sActiveClass)
		});
		DOC.on('mouseleave', sSelestor, function() {
			$(this)
				.find(sHover)
				.parent()
				.removeClass(sActiveClass)
		});
	}

  $('body').on('touchmove', function () {
    $('.games-item').each(function (){
      $(this).removeClass('games-item--with-overlay');
    })
  });
	// --- End Fix Hover on mobile -----------------------------------------------


    /**
     * Инициализация поля выбора даты
     * Используется в формах, которые подгружаются на ajax
     * Для этого вынесен в функцию для использования внутри ajaxSuccess
     **/
    function dateInit() {
        let input_date = $('[data-date]');
        if (input_date.length > 0 ) {
            if (!$('.datepickers-container').length) {
                let date = (new Date()).getFullYear();
                let maxdate = new Date();
                var datelang = HTML.attr('lang');

                maxdate.setYear(date - 18);

                input_date.datepicker({
                    maxDate: maxdate,
                    autoClose: true,
                    dateFormat: 'yyyy-mm-dd',
                    language: datelang
                });
            }
        }
    }

    // console.log(HTML.attr('lang'));

    dateInit();
    /** End **/

    /** Avatar load в профиле Игрока **/
    var readURL = function(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function(e) {
                $('.profile-pic').attr('src', e.target.result);
            };
            reader.readAsDataURL(input.files[0]);
        }
    };
    $('#avatar-form').submit(function() {
        readURL($('#avatar-input'));
    });

    $("[data-avatar-submit]").on('click', function() {
        $("[data-avatar-upload]").click();
    });

    /** End Avatar load в профиле Игрока **/

    /** Document load в кабинете Игрока **/
    $(".upload-button").on('click', function() {
        $(".file-upload").click();
    });
    /** End Document load в кабинете Игрока **/

    /** Определяем ширину скроллбара в текущем браузере !!! определить необходимость для данного проекта !!!????? **/
    var div = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';

    document.body.appendChild(div);
    var scrollWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    /** End Определяем ширину скроллбара в текущем браузере **/

    /**
     * Иниализация отложенной подгрузки изображений + замена битого изображения логотипом проекта
     * https://skeleton.gitbook.io/docs/js/jquery-lazy
     **/
    function lazyLoad() {
        $('[data-lazy] img[data-src]').Lazy({
            scrollDirection: 'vertical',
            effect: "fadeIn",
            effectTime: 1000,
            onError: function(el) {
              // el.attr("src","/front/img/logos/no-photo.png").parent().addClass('no-photo');
              el.parent().addClass('no-photo');
            }
        });
    }
    lazyLoad();

    /**
     * Условие проверки входа через IE
     * И вывод соответствующего сообщения об устаревшем браузере
     **/
    if (!HTML.hasClass('ie')) {
        $('.ieOff').remove();
    }
    /** End **/

    /**
     * Детектирование включенного AdBlock'a у пользователя
     * Если он активирован - выводим сообщение
     * При закрытии этого сообщение результат записываем в sessionStorage
     * и в следующий раз уже не отображаем сообщение
     **/
        //sessionStorage.clear();  // очищаем sessionStorage и показываем уведомление при каждой перезагрузке

    let alert_container = $('.alert');
    function adBlockDetected() {
        let alert_status = sessionStorage.getItem('alert');
        if (alert_status !== '0') {
            alert_container.show();
        }
    }
    if (typeof fuckAdBlock === 'undefined') {
        adBlockDetected();
    } else {
        fuckAdBlock.onDetected(adBlockDetected);
    }
    DOC.on('click', '[data-alert-close]', function() {
        alert_container.hide();
        sessionStorage.setItem('alert', '0');
    });

    /**
     * Инициализация модального окна, inline type
     */

    $('[data-modal-inline]').magnificPopup({
        type:'inline',
        midClick: true
    });

    /** Событие срабатывает в случае успешного выполнения ajax запроса **/
    $(document).on('ajaxSuccess', function() {
        fixHover('.games-item', '.games-item__overlay', 'games-item--with-overlay');
        selectInit();
        lazyLoad();
        dateInit();
        dataCutText();
        enterCode();
        calcTickerWidthHeader();
        calcTickerWidthPage();
    });
    /** Раскрытие меню провайдеров в футере **/


  // ---------------------------------------------------------------------------
  // ---------------------------------------------------------------------------
  /* ----------------------------- REFACTORED ------------------------------- */
  // ---------------------------------------------------------------------------
  // ---------------------------------------------------------------------------
  /**
   * Этот код подменяет ссылку на ссылках "Назад".
   * Смысл этих сложностей в том, чтобы поставить на ссылку "Назад" изначально повесить ссылку
   * на главную, которая сработает если посетитель пришел по прямой ссылке, а потом уже вешать
   * действительно предыдущую страницу, когда посетитель походил по страницам.
   * */
  if (window.sessionStorage.currPage) {
    if (!window.sessionStorage.prevPage || window.sessionStorage.currPage !== window.location.toString()) {
      window.sessionStorage.prevPage = window.sessionStorage.currPage;
    }
  }
  if (window.sessionStorage.prevPage) {
    $('[data-go-back]').attr('href', window.sessionStorage.prevPage);
  }
  window.sessionStorage.currPage = window.location.toString();

  /* Обработчик кнопки добавления в избранное */
  DOC.on('click', '[data-favorite]', function(){
    $(this).toggleClass('icon-favorite').toggleClass('icon-favorite-active').toggleClass('active');
  });

  /* Переключение пустой и заполненной страницы */
  DOC.on("change", "[data-page-switch]", function() {
    if($(this).find('input').is(':checked')){
      $('.pageSwitch--void').toggle();
      $('.pageSwitch--full').hide();
    }
    else {
      $('.pageSwitch--void').toggle();
      $('.pageSwitch--full').show();
    }
  });

  /* Удаление пробелов из инпута при вводе */
  DOC.on('change', '[data-trim]', function (){
      $(this).val($(this).val().trim());
  });

  /* Событие копирования в буфер обмена при клике на кнопку */
  DOC.on('click', '[data-wallet-copy]', function() {
    $('[data-wallet]').select();
    document.execCommand("copy");
  });

  // ---------------------------------------------------------------------------
  // ---------------------------------------------------------------------------
  // ---------------------------------------------------------------------------

  /* ----- Слайдер игр на главной ------------------------------------------ */
  function slidersGamesInit() {
    $('[data-slider-main-games]').each(function() {
      let container = $(this);

      let gameSlider = new Swiper(container.find('.swiper-container'), {
        // watchOverflow: true,
        loop: false,
        // centeredSlides: false,
        cssMode: true,
        slideClass: 'games-item',
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 32,

        // allowTouchMove: false,
        // simulateTouch: true,
        observeParents: true,
        observer: true,
        navigation: {
          nextEl: container.find('.swiper-arrow--next'),
          prevEl: container.find('.swiper-arrow--prev')
        },
        pagination: {
          el: container.find('.swiper-pagination'),
          clickable: true
        },
        breakpoints: {
          610: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 32
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 36
          }
        }
      });
    });
  }

  slidersGamesInit();

  /* pseudo-resize when open sidebar */
  // const sliderGamesWrapper = document.querySelectorAll('.slider-games');
  //
  // sliderGamesWrapper.forEach(sliderGamesItem => {
  //   new ResizeObserver(() => {
  //     slidersGamesInit();
  //   }).observe(sliderGamesItem);
  // });
  // ---------------------------------------------------------------------------


  /**
  *  Табы в виде трансформера из табов в селекты
  *
  *    data-tabs - аттрибут, по которому происходит инициализация работы табов
  *
  *    data-tabs-save - аттрибут, который, фактически активирует сохранение активного таба в LocalStorage
  *        Для него нужно указать имя, которое будет использоваться для идентификации текущей страницы
  *
  *    data-tabs-sync - аттрибут, который активирует синхронизацию двух табов
  *        Его нужно задать для того селекта, С КОТОРЫМ нужно синхронизировать активный
  *        Если задать для обоих селектов - синхронизация будет работать в обе стороны
  *
  *    data-tabs-transform - аттрибут, значение в котороым указывает ширину экрана, меньше которой табы будут трансформироваться в селект
  *
  *    data-tabs-selector - аттрибут, добавляем его в случае, если нужно сделать выделение таба, которое с анимацией
  *        передвигается после выделения таба
  *
  * */
  function newTabs(){
      let tabs_active = 'active',
          tabs_content = '.tabs__content';

      $('[data-tabs]').each(function (){
          $(this).selectric({
              maxHeight: 200,
              disableOnMobile: false,
              nativeOnMobile: false,
              responsive: false,
              arrowButtonMarkup: '<b class="selectric__button icon-arrow-down"></b>',
          })
          .prop('selectedIndex', 0).selectric('refresh')
          .on('change', function(){

              let tabs_parent = $(this).closest('.tabs__parent'),
                  tabs_save = $(this).closest('[data-tabs-save]'),
                  tabs_save_value = tabs_save.data('tabs-save'),
                  tabs_selected = $(this).parents('.selectric-wrapper').find('li.selected'),
                  tab_counter = tabs_selected.index();

              tabs_parent.find(tabs_content + ':first').parent().children(tabs_content).removeClass(tabs_active).eq(tab_counter).addClass(tabs_active);

              // если указан дата аттрибут для сохранения - сохраняем его в localStorage
              if(tabs_save.length && tabs_save_value.length){
                  localStorage.setItem(tabs_save_value, tab_counter);
              }

              // синхронизация двух селектов
              // в случае сложной адаптивной структуры, если по дизайну селект (табы) переносятся в другой блок
              $('[data-tabs-sync]').each(function (){
                  $(this).parents('.selectric-wrapper').find('li').removeClass('selected').eq(tab_counter).addClass('selected').trigger('click');
              })


              if($(this).closest('[data-tabs-selector]').length){
                  // добавляем координаты и ширину для выделения
                  $(this).closest('[data-tabs-selector]').parents('.selectric-wrapper').find('.tabs__select').css({
                      "left": tabs_selected.position().left + "px",
                      "width": tabs_selected.innerWidth() + "px"
                  });
              }


              slidersGamesInit();
          });

          // создаём элемент, который будет использоваться как выделение
          if($(this).closest('[data-tabs-selector]').length){
              let tabs_current = $(this).parents('.selectric-wrapper').find('li.selected');
              $(this).parents('.selectric-wrapper').find('.selectric-scroll').prepend('<span class="tabs__select" style="width: ' + tabs_current.innerWidth() + 'px; left:' + tabs_current.position().left + 'px"></span>');
          }

          // находим общего родителя для табов и контена табов и проставляем классы
          let tabs_parent = $($(this).parents().get().find(itm => $(itm).find(tabs_content).length)),
              tabs_save = $(this).closest('[data-tabs-save]'),
              tabs_save_value = tabs_save.data('tabs-save');

          tabs_parent.addClass('tabs__parent');

          // если установлено сохранение активного таба - при загрузке страницы эмулируем клик на него
          if(tabs_save.length && tabs_save_value.length){
              setTimeout(function() {
                  // если не будет установлено ни одного active у контента, то добавляем его сами
                  tabs_parent.find(tabs_content).eq(localStorage.getItem(tabs_save_value)).addClass(tabs_active);

                  tabs_save.parents('.selectric-wrapper').find('li:eq(' + localStorage.getItem(tabs_save_value) + ')').trigger('click');
              }, 1);
          }
      });
  }
  newTabs();

  /**
  * Значение, при котором изменяется тип табов (табы или селект) задается в дата-аттрибут data-tabs-transform
  */
  function tabsTypeCheck(){
      $('[data-tabs-transform]').each(function (){
          let windowWidth = $(this).data('tabs-transform');
          if(WIN.width() <= windowWidth){
              $(this).parents('.select').removeClass('select--tabs').addClass('select--transformed');
          }
          else{
              $(this).parents('.select').addClass('select--tabs').removeClass('select--transformed');

          }
      });
  }
  tabsTypeCheck();


  /**
  * Пересчёт позиции выделения табов (если есть аттрибут data-tabs-selector)
  * */
  function tabsSelect(){
      $('[data-tabs]').each(function (){
          var attr = $(this).data('tabs-selector');

          if (typeof attr !== typeof undefined && attr !== false) {
              let tabs_selected = $(this).parents('.selectric-wrapper').find('li.selected');

              $(this).closest('[data-tabs-selector]').parents('.selectric-wrapper').find('.tabs__select').css({
                  "left": tabs_selected.position().left + "px",
                  "width": tabs_selected.innerWidth() + "px"
              });
          }


          if($(this).data('tabs-selector')){

          }
      });
  }
  tabsSelect();
  /** End New tabs **/

  // ----- Phone Inputs plugin init --------------------------------------------
	var input = document.querySelector("input[type=tel]");

  if ($("input[type=tel]").length) {
    window.intlTelInput(input, {
      initialCountry: "auto",
      autoHideDialCode: false,
      nationalMode: false,
      // separateDialCode: true,
      // hiddenInput: "full_phone",
      numberType: "MOBILE",
      geoIpLookup: function(callback) {
        $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
          var countryCode = (resp && resp.country) ? resp.country : "";
          callback(countryCode);
        });
      },
      utilsScript: "/front/js/utils.js"
    });
		//-- обертка для телефонных номеров
    $('.iti__country-list').each(function() {
      $(this).wrap('<div class="iti__country-list--wrapper">');
    });
    // переносим список стран на уровень выше
    $('.iti').append($('.iti__country-list--wrapper'));
    // добавляем класс обертке, когда список открыт
    input.addEventListener('open:countrydropdown', function() {
      $(this).closest('.form__input').addClass("focused");
    });
    // удаляем класс обертке, когда список открыт
    input.addEventListener('close:countrydropdown', function() {
      $(this).closest('.form__input').removeClass("focused");
    });
  }
	// ---------------------------------------------------------------------------

  /* ----- Инициализация select menu ---------------------------------------- */
  function selectInit() {
    $('[data-select-menu]').each(function() {
      if (!$(this).parent().hasClass('selectric-hide-select')) {
        $(this).selectric({
          maxHeight: 264,
          disableOnMobile: false,
          nativeOnMobile: false,
          arrowButtonMarkup: '<b class="selectric__button icon-arrow-down"></b>',
          onInit: function() {
            var current_option = $(this),
                current_option_value = current_option.val(),
                selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

            // проверка для вывода поля с секретным ответом
            if (typeof current_option.attr('data-secret-question') !== typeof undefined && current_option.attr('data-secret-question') !== false) {
              if (current_option_value) {
                secret_answer.show();
              }
              else {
                secret_answer.hide();
              }
            }

            //  эмуляция placeholder'a для селектрика
            if (current_option_value) {
              selectric_container.removeClass('selectric--placeholder');
            } else {
              selectric_container.addClass('selectric--placeholder');
            }

            // проверка на количество эллементов, если 1 - то добавляем класс,
            // который скрывает всю навигацию
            if (current_option.find('option').length === 1) {
              current_option.parents('.selectric-wrapper').addClass('selectric--void');
            }
        },
        onChange: function(element) {
          var current_option = $(this),
              current_option_value = current_option.val(),
              selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

            // проверка для вывода поля с секретным ответом
            if (typeof current_option.attr('data-secret-question') !== typeof undefined && current_option.attr('data-secret-question') !== false) {
              if (current_option_value) {
                secret_answer.show();
              }
              else {
                secret_answer.hide();
              }
            }

            //  эмуляция placeholder'a для селектрика
            if (current_option_value) {
              selectric_container.removeClass('selectric--placeholder');
            } else {
              selectric_container.addClass('selectric--placeholder');
            }
          },
        });
      }
    });
  }
  selectInit();
  // ---------------------------------------------------------------------------

  /**
  * Создание резинового меню
  * https://skeleton.gitbook.io/docs/js/response-menu
  * **/
  function responseMenu(){
    $('[data-menu]').each(function (){
      let menu_container = $(this),
          menu_more,
          menu_more_link;

      // вставляем элемент со скрытым списком
      if(!menu_container.find('.menu-dd__item').length){
        menu_more = menu_container.find('li:first-of-type').clone().addClass("menu-dd__item");
        menu_container.prepend(menu_more);
        menu_more_link = menu_more.find('> * ');

        let attr = $(this).data('menu-icon'),
            menu_icon = '';

        if (typeof attr !== typeof undefined && attr !== false) {
          menu_icon = '<i class="' + attr + '"></i>'
        }

        menu_more_link.replaceWith(function () {
          return $('<span class="' + menu_more_link.attr('class') +' menu-dd__button">' + menu_icon + '<span>' + menu_container.data('menu') +'</span></span>');
        });
        menu_more.append('<ul class="menu-dd__dropdown"></ul>');
      }

      menu_container.find('.menu-dd__dropdown li').appendTo(menu_container);

      let
          items = menu_container.find(' > li:not(.menu-dd__item)'),
          menu_button = menu_container.find('.menu-dd__item'),
          menu_maxWidth = parseInt(menu_container.width()) - parseInt(menu_button.outerWidth()),

          menu_width = 0, // общая длина меню (сума длинны видимых пунктов)
          menu_hideFrom = 0, // начиная с какого по порядку пункту меню переносим пункты в подменю
          menu_hideFrom_custom = menu_container.data('menu-max') - 1;

      items.each(function(index){
        // округляем ширину текущего пункта меню до целого числа в большую сторону
        let item_width = Math.ceil($(this).outerWidth());

        if (menu_width + item_width > menu_maxWidth){
          return false;
        }
        else{
          // считаем, начиная с какого пункта нужно переносить пункты в подменю
          menu_hideFrom = index;

          // считаем общую ширину всех видимых пунктов меню
          menu_width += item_width;
        }
      });

      if (menu_hideFrom_custom && menu_hideFrom_custom < menu_hideFrom){
        menu_hideFrom = menu_hideFrom_custom;
      }

      // переносим пункты меню в дропдаун
      if (menu_hideFrom < parseInt(items.length)) {
        items.eq(menu_hideFrom).nextAll('li').appendTo(menu_container.find('.menu-dd__dropdown'));
        menu_button.addClass('menu-dd__item--active').removeClass('active');

        if ( menu_container.find('.menu-dd__dropdown li').length < 1 ) {
          menu_button.removeClass('menu-dd__item--active');
        }
      }
      else {
        menu_button.removeClass('menu-dd__item--active');
      }
    });
  }

  responseMenu();

  /* pseudo-resize when open sidebar */
  const responseMenuWrapper = document.querySelectorAll('.games-providers-search__inner');
  responseMenuWrapper.forEach(responseMenuItem => {
    new ResizeObserver(() => {
      responseMenu();
    }).observe(responseMenuItem);
  });


  DOC.on('click', '.menu-dd__button', function () {
    $(this).parent().toggleClass('open');
  });

  /**
   * Закрытие блока при клике вне его пределов
   * */
  DOC.on('click', function(e){
    // резиновое меню
    if (!$(e.target).closest(".menu-dd__item, .menu-dd__dropdown").length) {
      $('[data-menu] .menu-dd__item').removeClass('open');
    }
    e.stopPropagation();
  });
	// ---------------------------------------------------------------------------

  /* ----- Слайдер провайдеров в футере ------------------------------------- */
  var providersSlider = new Swiper('[data-providers-slider] .swiper-container', {
    loop: false,
    slidesPerView: 7,
    slidesPerGroup: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: '[data-providers-slider] .swiper-arrow--next',
      prevEl: '[data-providers-slider] .swiper-arrow--prev'
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 4
      },
      1440: {
        slidesPerView: 5
      }
    }
  });
  /* ----- End слайдер провайдеров в футере --------------------------------- */


  /* ----- Триггер открытия меню для мобилок в футере ----------------------- */
  $('[data-footer-mobile-opener]').click(function() {
		$(this).closest('.footer__menu-heading').toggleClass('opened').siblings('.footer__menu-list').stop().slideToggle(200);
	});
  /* ----- End триггер открытия меню для мобилок в футере ------------------- */

  /** sidebar toggler for open/close **/
  DOC.on('click', '[data-sidebar-closer]:not(.opened)', function(event) {
    event.preventDefault();
    $('.helper').addClass('opened');
    $('[data-sidebar]').addClass('opened');
    $('[data-sidebar-closer]').addClass('opened');
    localStorage.setItem('sidebarOpenedStorage', 'opened');

    calcTickerWidthPage();
    calcTickerWidthHeader();
  });

  DOC.on('click', '[data-sidebar-closer].opened', function() {
    $('.helper').removeClass('opened');
    $('[data-sidebar-closer]').removeClass('opened');
    $('[data-sidebar]').removeClass('opened');
    localStorage.removeItem('sidebarOpenedStorage');

      calcTickerWidthPage();
      calcTickerWidthHeader();

  });

  DOC.on('click', '.sidebar__section-item .sidebar__section-item-icon', function() {
    if ( !$(this).closest('.sidebar').hasClass('opened') ) {
      event.preventDefault();
      $('.helper').addClass('opened');
      $('[data-sidebar]').addClass('opened');
      $('[data-sidebar-closer]').addClass('opened');
      localStorage.setItem('sidebarOpenedStorage', 'opened');

      if ( !$(this).siblings('.sidebar__section-item-content').children('.sidebar__section-item-heading').hasClass('opened') ) {
        $(this).siblings('.sidebar__section-item-content').children('.sidebar__section-item-heading').toggleClass("opened").next().slideToggle();
      }
    }
  });

  // при ресайзе (только горизонтальном) эмулируем клик на body, из-за этого срабатывает скрипт закрытия блока меню
  var w = $(window).width();
  WIN.on('resize', function() {
    if ($(window).width()==w) return;
      w = $(window).width();
      if ($('[data-sidebar-closer]').hasClass('opened')) {
        $('[data-sidebar-closer]').removeClass('opened');
      }
      if ($('[data-sidebar]').hasClass('opened')) {
        $('[data-sidebar]').removeClass('opened');
      }
      if ($('.helper').hasClass('opened')) {
        $('.helper').removeClass('opened');
      }
  });

  var sidebarOpened = localStorage.getItem('sidebarOpenedStorage');

  if (sidebarOpened !== null && w > 1024) {
    $('.helper').addClass('opened');
    $('[data-sidebar]').addClass('opened');
    $('[data-sidebar-closer]').addClass('opened');
  }
  else {
    $('.helper').removeClass('opened');
    $('[data-sidebar-closer]').removeClass('opened');
    $('[data-sidebar]').removeClass('opened');
  }

  /* ----- Language select -------------------------------------------------- */
  DOC.on('click', '.lang-select', function() {
    $(this).toggleClass('open');
  });
  $(".lang-select .lang-select__item").click(function() {
    $(this).siblings(".lang-select__item").removeClass('active');
    $(this).toggleClass('active')
  });

  /** Закрытие списка языков при клике вне его **/
  DOC.on('click', function(e) {
    if (!$(e.target).closest(".lang").length) {
      $('.lang-select').removeClass('open');
    }
    e.stopPropagation();
  });
  /* ------------------------------------------------------------------------ */

  /* ----- Profile menu in header ------------------------------------------- */
  DOC.on("click", "[data-user-info-toggler]", function() {
    $(this).toggleClass('opened').children('.user-info__avatar-menu').slideToggle(200);
  });

  /** Закрытие меню профиля при клике вне его **/
  DOC.on('click', function(e) {
    if (!$(e.target).closest("[data-user-info-toggler]").length) {
      $("[data-user-info-toggler]").removeClass('opened').children('.user-info__avatar-menu').slideUp(200);
    }
    e.stopPropagation();
  });
  /* ------------------------------------------------------------------------ */

  /* ---- Инициализация select menu валют ----------------------------------- */
  $('[data-select-currency]').selectric({
    disableOnMobile: false,
    nativeOnMobile: false,
    arrowButtonMarkup: '<b class="selectric__button"></b>',
    onInit: function() {
      $(this).parents('.selectric-wrapper').addClass('selectric-wrapper--small');
      if ($(this).find('option').length === 1) {
        $(this).parents('.selectric-wrapper').addClass('selectric--void');
      }
    },
    optionsItemBuilder: function(itemData) {
	    return itemData.value.charAt(0) == '/' ? '<a href="' + itemData.value + '">' + itemData.text + '</a>' : '<span>' + itemData.text + '</span>';
	  }
  }).on('change', function() {
      location.href = $(this).val();
  });
  /* ------------------------------------------------------------------------ */

  /* ----- Sidemenu / Opened / Toggler -------------------------------------- */
  $("[data-sibedar-section-toggler]").click(function() {
    $(this).closest(".sidebar__section-item-heading").toggleClass("opened").next().slideToggle();
  });
  /* ------------------------------------------------------------------------ */

  /* ----- Слайдер новостей на главной -------------------------------------- */
  const breakpointNews = window.matchMedia( '(min-width:1025px)' );
  let newsSwiper;

  const breakpointCheckerNews = function() {
    if ( breakpointNews.matches === true ) {
      // clean up old instances and inline styles when available
  	  if ( newsSwiper !== undefined ) newsSwiper.destroy( true, true );
  	  // or/and do nothing
  	  return;
    // else if a small viewport and single column layout needed
  } else if ( breakpointNews.matches === false ) {
      // fire small viewport version of swiper
      return enableNewsSwiper();
    }
  };

  const enableNewsSwiper = function() {
    newsSwiper = new Swiper ('[data-news-slider] .swiper-container', {
      loop: false,
      // initialSlide: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 32,
      observer: true,
      observeParents: true,
      pagination: {
        el: '[data-news-slider] .swiper-pagination',
        clickable: true
      },
      breakpoints: {
        620: {
          slidesPerView: 1,
          slidesPerGroup: 1
        },
        1024: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      }
    });
  };

  // keep an eye on viewport size changes
  breakpointNews.addListener(breakpointCheckerNews);
  // kickstart
  breakpointCheckerNews();


  /**
   * Cлайдер на странице c играми
   * + хак для loop, чтобы отрабатывал watchOverflow: true (скрывается пагинация\навигация, если только 1 слайд)
   * */
  var mainSlider = new Swiper('[data-slider-main] .swiper-container', {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      disableOnInteraction: true
    },
    effect: 'fade',
    lazy: true,
    pagination: {
      el: '[data-slider-main] .swiper-pagination',
      clickable: true
    }
  });
  // ---------------------------------------------------------------------------

  /* ----- Слайдер победителей на главной странице -------------------------- */
  var winnersGameSlider = new Swiper('[data-slider-winners-vertical] .swiper-container', {
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 0,
    direction: 'vertical',
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    lazy: true
  });

  /* ----- Слайдер победителей на странице игры ----------------------------- */
  var winnersGameSlider = new Swiper('[data-slider-winners-vertical--game] .swiper-container', {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 0,
    direction: 'vertical',
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    lazy: true
  });
  // ---------------------------------------------------------------------------

  /* ----- Слайдер победителей на главной ----------------------------------- */
  const breakpointWinners = window.matchMedia( '(min-width:1025px)' );
  let winnersSwiper;

  const breakpointCheckerWinners = function() {
    if ( breakpointWinners.matches === true ) {
      // clean up old instances and inline styles when available
      if ( winnersSwiper !== undefined ) winnersSwiper.destroy( true, true );
      // or/and do nothing
      return;
    // else if a small viewport and single column layout needed
  } else if ( breakpointWinners.matches === false ) {
      // fire small viewport version of swiper
      return enableWinnersSwiper();
    }
  };

  const enableWinnersSwiper = function() {
    winnersSwiper = new Swiper ('[data-slider-main-winners] .winners__groups-swiper-container', {
      loop: false,
      effect: 'fade',
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 32,
      pagination: {
        el: '[data-slider-main-winners] .swiper-pagination-groups',
        clickable: true
      },
      breakpoints: {
        620: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      }
    });
  };

  // keep an eye on viewport size changes
  breakpointWinners.addListener(breakpointCheckerWinners);
  // kickstart
  breakpointCheckerWinners();
  /* ------------------------------------------------------------------------ */

  // Open Block Seo-text -------------------------------------------------------
  $('[data-seo-show-more]').on('click', function() {
    $(this).toggleClass('opened').closest('.seo-text__wrapper').toggleClass('opened');
  });
  // Open Block Game Description -----------------------------------------------
  $('[data-game-show-more]').on('click', function() {
    $(this).toggleClass('opened').closest('.game__description').toggleClass('opened');
  });
  // ---------------------------------------------------------------------------

  // ------ Инициализация "маленького" (турниры) select menu валют -------------
  $('[data-select-menu-small]').selectric({
    disableOnMobile: false,
    nativeOnMobile: false,
    arrowButtonMarkup: '<b class="selectric__button"></b>',
    onInit: function() {
      $(this).parents('.selectric-wrapper').addClass('selectric-wrapper--small');
      if ($(this).find('option').length === 1) {
        $(this).parents('.selectric-wrapper').addClass('selectric--void');
      }
    }
  });
  // ----- End Инициализация "маленького" select menu валют --------------------

  // --- Слайдер prizes на странице турнира ------------------------------------
  var prizesSlider = new Swiper('[data-prizes-slider] .swiper-container', {
    speed: 1000,
    loop: false,
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 32,
    navigation: {
      nextEl: '[data-prizes-slider] .swiper-arrow--next',
      prevEl: '[data-prizes-slider] .swiper-arrow--prev'
    },
    pagination: {
      el: '[data-prizes-slider] .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      620: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 2
      },
      1300: {
        slidesPerView: 3
      }
    }
  });
  // --- End prizes на странице турнира ----------------------------------------

  // ----- Providers select / games-search-providers panel ---------------------
  $('[data-providers-toggler]').on('click', function() {
    $(this).toggleClass('opened');
    $('[data-providers-wrapper]').toggleClass('opened');
  });
	DOC.on('click', function(e) {
    if (!$(e.target).closest(".providers-menu").length) {
      $('[data-providers-toggler]').removeClass('opened');
			$('[data-providers-wrapper]').removeClass('opened');
    }
    e.stopPropagation();
  });
	// ---------------------------------------------------------------------------

  // ----- Game types select (for mobiles) / games-search-providers panel ------
  $('[data-games-types-toggler]').on('click', function() {
    $(this).toggleClass('opened').siblings('[data-games-types-wrapper]').toggleClass('opened');
  });

	DOC.on('click', function(e) {
    if (!$(e.target).closest(".games-types-select").length) {
      $('[data-games-types-toggler]').removeClass('opened');
			$('[data-games-types-wrapper]').removeClass('opened');
    }
    e.stopPropagation();
  });
	// ---------------------------------------------------------------------------

  /** обрезка текстовых привью (количество символов береться из дата атрибута) **/
  function dataCutText() {
    var shortText= $('[data-cut-text]');
    shortText.each(function(){
      var size = $(this).data('cutText'),
        elementText = $.trim($(this).text());
      if(elementText.length > size){
        $(this).text(elementText.slice(0, size) + '...');
      }
    });
  }

  dataCutText();
  // ---------------------------------------------------------------------------

  // ------ tournaments list description cut text ------------------------------
  function dataCutTextTournaments() {
    $('.tournaments__item-description-original').each(function() {
      if (window.innerWidth <= 1300) {
        var size = 130,
            desktopDesc = $.trim($(this).text());

        if (desktopDesc.length > size) {
          $(this).siblings('.tournaments__item-description-cuted').text(desktopDesc.slice(0, size) + '...');
        }
      }
      else {
        var size = 485,
            tabletsDesc = $.trim($(this).text());
        if (tabletsDesc.length > size) {
          $(this).siblings('.tournaments__item-description-cuted').text(tabletsDesc.slice(0, size) + '...');
        }
      }

    });
  }
  dataCutTextTournaments();
  // ---------------------------------------------------------------------------

  // ------ messages list description cut text ---------------------------------
  function dataCutTextMessages() {
    $('.msg__item-content-original').each(function() {
      if (window.innerWidth <= 620) {
        var size = 65,
            mobileDesc = $.trim($(this).text());

        if (mobileDesc.length > size) {
          $(this).siblings('.msg__item-content-cuted').text(mobileDesc.slice(0, size) + '...');
        }
      }
      else if (window.innerWidth <= 1024) {
        var size = 125,
            tabletDesc = $.trim($(this).text());

        if (tabletDesc.length > size) {
          $(this).siblings('.msg__item-content-cuted').text(tabletDesc.slice(0, size) + '...');
        }
      }
      else if (window.innerWidth <= 1300) {
        var size = 185,
            smallDesktopDesc = $.trim($(this).text());

        if (smallDesktopDesc.length > size) {
          $(this).siblings('.msg__item-content-cuted').text(smallDesktopDesc.slice(0, size) + '...');
        }
      }
      else {
        var size = 390,
            bigDesktopsDesc = $.trim($(this).text());
        if (bigDesktopsDesc.length > size) {
          $(this).siblings('.msg__item-content-cuted').text(bigDesktopsDesc.slice(0, size) + '...');
        }
      }

    });
  }
  dataCutTextMessages();
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // --- new timers ------------------------------------------------------------
  /* tournaments timer */
  let serverTimers = $('[data-server-timer-tournaments]')
  if (serverTimers.length) {
    const timer = CountdownTimer.getInstance();
    serverTimers.each((_, el) => {
    const observer = new CountdownTimerObserver(el, (timerData) => {
    return `
      <div class="tournaments__timer-group">
        <span class="tournaments__timer-amount">${timerData.days}</span>
        <span class="tournaments__timer-text">${timerData.daysLabel}</span>
      </div>
      <div class="tournaments__timer-group">
        <span class="tournaments__timer-amount">${timerData.hours}</span>
        <span class="tournaments__timer-text">${timerData.hoursLabel}</span>
      </div>
      <div class="tournaments__timer-group">
        <span class="tournaments__timer-amount">${timerData.minutes}</span>
        <span class="tournaments__timer-text">${timerData.minutesLabel}</span>
      </div>
      <div class="tournaments__timer-group">
        <span class="tournaments__timer-amount">${timerData.seconds}</span>
        <span class="tournaments__timer-text">${timerData.secondsLabel}</span>
      </div>
    `;
    });
    timer.attach(observer);

    });
    timer.start();
  }
  /* bonuses timer */
  let serverBonusesTimers = $('[data-server-timer-bonuses]')
  if (serverBonusesTimers.length) {
    const timerBonuses = CountdownTimer.getInstance();
    serverBonusesTimers.each((_, el) => {
    const observerBonuses = new CountdownTimerObserver(el, (timerData) => {
    return `
      <div class="bonuses__timer-time-group">
        <div class="bonuses__timer-time-amount">${timerData.days}</div>
        <div class="bonuses__timer-time-text">${timerData.daysLabel}</div>
      </div>
      <div class="bonuses__timer-time-group">
        <div class="bonuses__timer-time-amount">${timerData.hours}</div>
        <div class="bonuses__timer-time-text">${timerData.hoursLabel}</div>
      </div>
      <div class="bonuses__timer-time-group">
        <div class="bonuses__timer-time-amount">${timerData.minutes}</div>
        <div class="bonuses__timer-time-text">${timerData.minutesLabel}</div>
      </div>
    `;
    });
    timerBonuses.attach(observerBonuses);

    });
    timerBonuses.start();
  }
  // ---------------------------------------------------------------------------

  /* ----- Событие смены видимости пароля в инпуте -------------------------- */
  var passwordToggler = ('[data-password-toggler]');
  DOC.on('click', passwordToggler, function() {
    var btn = $(this),
        input = btn.siblings('input');
    btn.toggleClass('icon-view');
    btn.toggleClass('icon-hide');
    if (input.attr('type') == 'text') {
      input.attr('type', 'password').removeClass('toggled');
    } else {
      input.attr('type', 'text').addClass('toggled');
    }
  });
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // Событие клика на элементе faq. Показывает\скрывает ответ на вопрос */
  $('[data-faq-question]').click(function() {
    $(this).closest('.faq__item').toggleClass('faq__item---open');
    $(this).siblings('.faq__item-answer').slideToggle(200);
  });
  // ---------------------------------------------------------------------------

  // ----- Game Page: fullscreen -----------------------------------------------
  $('[data-game-fullscreen]').click(function() {
    // $(this).toggleClass('active');
    $('.game__iframe iframe, .game__iframe img').fullscreen();
  });
  // ----- Game page: fullwidth  -----------------------------------------------
  $('[data-game-fullwidth]').click(function() {
    $(this).toggleClass('active').closest('.game').toggleClass('fullwidth');
  });
  // ----- Game page: accordion  -----------------------------------------------
  DOC.on('click', '[data-accordion-trigger]', function() {
    $(this).closest('.accordion__item').toggleClass('accordion__item--open');
  });
  // ---------------------------------------------------------------------------

  /** Вызов user navigation (menu) в модалке **/
  $('[data-user-navigation]').on("click", function () {
    // This prevents the page from scrolling down to where it was previously.
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo(0,0);
    $(this).parents().find('.container').toggleClass('open');
  });
  $('[data-back-profile]').on("click", function () {
      $(this).parents().find('.container').removeClass('open');
  });
  /** End Вызов user navigation (menu) в модалке **/

  // ---------------------------------------------------------------------------
  // ----- 2fac confirmation code: 6 inputs ------------------------------------
  $('body').on('keyup', '[data-inputs-group] input', function() {
    /* focus next input after fill prev */
    if (this.value.length == this.maxLength) {
      $(this).next('[data-inputs-group] input').focus();
    }
    /* delete value */
    var key = event.keyCode || event.charCode;
    if( key == 8 || key == 46 ){
      $(this).prev('[data-inputs-group] input').focus().select();
    }
  });
  /**
   * Поля ввода верификационного кода на странице 2fac / script for integration
   **/
  function enterCode() {
      let $formCode = $('[data-2fac-auth]');
      let $inputCode = $formCode.find('input[type="number"]');
      $inputCode.keydown(function (e) {
          // $(this).val('');
          if (e.key === 'Enter' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
              return $(this).val();
          } else $(this).val('');
      });

      $inputCode.keyup(function (e) {
          let val = $(this).val();

          // Ввод только цифр
          if (/^\d+$/.test(val) === false) {
              $(this).val('');
              $formCode.find('input.hidden-code').change();
              return false;
          }

          // Передача фокуса следующему input
          $inputCode.eq($inputCode.index(this) + 1).focus();

          // Заполнение input hidden
          let fullval = '';
          $inputCode.each(function () {
              fullval = fullval + $(this).val();
          });
          $formCode.find('input.hidden-code').val(fullval);
          $formCode.find('input.hidden-code').change();
      });

      $inputCode.keyup(function (e) {
          if (e.key === 'Backspace') {
              $inputCode.eq($inputCode.index(this) - 1).focus();
              $(this).val('');
          } else if (e.key === 'ArrowLeft') {
              $inputCode.eq($inputCode.index(this) - 1).focus();
          } else if (e.key === 'ArrowRight') {
              $inputCode.eq($inputCode.index(this) + 1).focus();
          }
      });
  }
  enterCode();
  // ---------------------------------------------------------------------------

  /* --- Копирование текста clipboard / input only! / with id only! --------- */
  $('[data-clipboard]').click(function(e) {
    let copyText = document.getElementById("copy-text");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
  });
  // ---------------------------------------------------------------------------

  // ----- new "games search" widget fixes -------------------------------------
  DOC.on('click', '[data-search]', function (){
    $('.search-modal').show();
    $('body').addClass('fixed blur');
  });

	$('[data-games-search-close]').on('click', function() {
    $('.search-modal').hide();
    $('body').removeClass('fixed blur');
  });

  $('[data-games-search-close-bg]').on('click', function() {
    $('.search-modal').hide();
    $('body').removeClass('fixed blur');
  });
	// ---------------------------------------------------------------------------

  // ----- ticker / running stroke ---------------------------------------------
  function calcTickerWidthHeader() {
    var totalTickerInnerWidth = 0;
    $('header.header .header__ticker-text p').each(function(index) {
      totalTickerInnerWidth += parseInt($(this).width(), 10);
    });
    var totalTickerWidth = $('header.header .header__ticker-inner').width();
        if (totalTickerInnerWidth > totalTickerWidth) {
          $('header.header .header__ticker-text').addClass('animated');
        }
        if (!$('header.header .header__ticker-text.animated p div').hasClass("js-marquee-wrapper")){
          $('header.header .header__ticker-text.animated p').marquee({
              css3easing: 'linear',
              easing: 'linear',
              delayBeforeStart: 3000,
              direction: 'left',
              duplicated: true,
              duration: 50000,
              gap: 200,
              pauseOnCycle: false,
              pauseOnHover: true,
              startVisible: true
          });
        }
  }
  calcTickerWidthHeader();



  function calcTickerWidthPage() {
    var totalTickerInnerWidth = 0;
    $('.page__ticker .header__ticker-text p').each(function(index) {
      totalTickerInnerWidth += parseInt($(this).width(), 10);
    });
    var totalTickerWidth = $('.page__ticker .header__ticker-inner').width();
      if (totalTickerInnerWidth > totalTickerWidth) {
            $('.page__ticker .header__ticker-text').addClass('animated');
      }
      if (!$('.page__ticker .header__ticker-text.animated p div').hasClass("js-marquee-wrapper")){
          $('.page__ticker .header__ticker-text.animated p ').marquee({
              allowCss3Support: true,
              css3easing: 'linear',
              easing: 'linear',
              delayBeforeStart: 3000,
              direction: 'left',
              duplicated: true,
              duration: 50000,
              gap: 200,
              pauseOnCycle: true,
              pauseOnHover: true,
              startVisible: true
          });
      }
  }
  calcTickerWidthPage();



    // ---------------------------------------------------------------------------


  /**
  * Действия при ресайзе окна
  * */
  WIN.on('resize', function() {
    // проверка типа табов
    tabsTypeCheck();

    // ресайз меню
    responseMenu();

    // седлекто-табы
    tabsSelect();

    // tournaments list description
    dataCutTextTournaments();

    // messages list description
    dataCutTextMessages();

    // ticker / running stroke
    calcTickerWidthHeader();
    calcTickerWidthPage();


  });

  // при ресайзе (только горизонтальном) эмулируем клик на body
  // из-за этого срабатывает скрипт закрытия блока меню
  var w = $(window).width();

  WIN.on('resize', function() {
    if ($(window).width()==w) return;
    w = $(window).width();
    BODY.trigger('click');
  });


  // // FOR LOCAL registration bonus add class active
  // function bonusCheck() {
  //     $('.special-radio__list .special-radio input').each(function() {
  //         $(this).parent().removeClass('special-radio__active');
  //
  //         if ($(this).is(':checked')) {
  //             $(this).parent().addClass('special-radio__active');
  //         }
  //     });
  // }
  //
  // DOC.on('click', '.special-radio__list .special-radio', function(){
  //     bonusCheck();
  // });
  //
  // bonusCheck();
  // // END registration bonus add class active

});
